<script setup lang="ts">
import { ref } from 'vue'
import video_url from '../../assets/img/icbm_cropped.mp4'
import CButton from '../components/CButton.vue'

const has_ordered_pizza = ref(false)

</script>

<template>
	<main class="l-row l-stack">
		<template v-if="! has_ordered_pizza">
			<h1>Order a Pizza</h1>

			<c-button @click="has_ordered_pizza = ! has_ordered_pizza">
				Place your order
			</c-button>

			<p>Guaranteed worldwide delivery within 22 minutes!</p>
		</template>
		<template v-else>
			<h1>Order placed!</h1>

			<video class="c-order-pizza__video" autoplay muted>
				<source :src="video_url" type="video/mp4">
			</video>

			<p>Your pizza will be delivered by ICBM within the next 22 minutes!</p>

			<aside class="c-order-pizza__footer">
				<p>This meme was a high-value feature for me to implement</p>
				<p>I am good at software development</p>
			</aside>
		</template>
	</main>
</template>

<style lang="scss">
	.c-order-pizza {
		&__video {
			width: 100%;
			height: auto;
		}

		&__footer {
			font-size: 0.875rem;
			opacity: 0.5;
			margin-top: 8rem;
		}
	}
</style>import CButtonVue from '../components/CButton.vue';
